import Seo from "../components/Seo";

export default function Accessibility() {
  return (
    <div data-testid="page-accessibility" className="bg-white">
      <Seo title="Accessibility Statement" description="Our commitment to accessible design at The Mogul Group Advisors." path="/accessibility" />
      <div className="container-wide py-20 max-w-3xl">
        <div className="overline mb-4">Accessibility</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight">Accessibility Statement</h1>
        <div className="mt-8 space-y-6 text-[#4B5563] leading-relaxed text-[15px]">
          <p>The Mogul Group Advisors is committed to making its website usable for everyone, including people with disabilities. We strive to meet modern accessibility standards including WCAG 2.1 AA where practical.</p>
          <h2 className="font-serif text-xl text-[#0A0A0A] pt-4">What we do</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Strong color contrast on text and interactive elements.</li>
            <li>Keyboard navigation for all interactive elements.</li>
            <li>Visible focus indicators.</li>
            <li>Labeled form controls and accessible error messages.</li>
            <li>Descriptive alt text for meaningful images.</li>
            <li>Support for the operating system's reduced-motion setting.</li>
          </ul>
          <h2 className="font-serif text-xl text-[#0A0A0A] pt-4">Contact</h2>
          <p>If you encounter an accessibility barrier on this website, please contact info@TheMogulAdvisors.com and we will address it promptly.</p>
        </div>
      </div>
    </div>
  );
}
